import './allarticles.css';
import { Link } from 'react-router-dom'
import { IoSearchSharp } from "react-icons/io5";

import axios from 'axios';
import { useEffect } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import emailContext from './emailcontext';
import articleContext from './articlecontext';

export default function Allarticles() {
    const [email, setEmail] = useContext(emailContext)

    const [artdata, setArtdata] = useContext(articleContext)
    const [search, setSearch] = useState("")
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const data = await axios.get('https://dojma-website-2pip.onrender.com/data')
                // console.log(data.data[0].name)
                setArtdata(data.data.slice().reverse());
                // console.log(data.data)
            } catch (error) {
                console.log(error)
            }
        }
        if (!artdata || artdata.length === 0) { fetchdata() }
    }, []);
    function hi(em) {
        const list12 = ["f20240626@goa.bits-pilani.ac.in"]

        for (let i = 0; i < list12.length; i++) {
            if (list12[i] === em) {
                return true
            }
        }
        return false
    }

    function button() {
        return <>
            <Link to={'/add_article'}> plus button </Link>
        </>
    }
    function nobutton() {
        return;
    }
    return (<><div className='upp'>


        <div className='alla'>ALL ARTICLES</div>
        <div>
            <input className='search' onChange={(e) => { setSearch(e.target.value) }} /><IoSearchSharp className='searcher' />
        </div>



    </div>
        <div>{hi(email) ? button() : nobutton()}</div>

        <div className='biggerfigner'>
            <div className='biggerfig'>

                <div className='wind'>

                    {artdata.filter((item) => {
                        const searchLower = search.toLowerCase();
                        return (item.body?.toLowerCase().includes(searchLower) ||
                            item.title?.toLowerCase().includes(searchLower) ||
                            item.candidatename?.toLowerCase().includes(searchLower) ||
                            item.position?.toLowerCase().includes(searchLower));
                    }).map((item, index) => (
                        <div key={index}><Link className='out' to={`/article/${index}`} >
                            <div className='in'><div className='title'>
                                {(item.opinion?.toLowerCase() === "acadassoc")
                                    ? `${item.position}, ${item.subject} - ${item.candidatename}`
                                    : (item.opinion?.toLowerCase() === "csa") ? `${item.position} - ${item.candidatename}` : item.title}
                            </div>

                                <div className={item.opinion}>
                                    {item.opinion}
                                </div>
                                <div className='outdatetime'>
                                    <div className='dater'>
                                        {item.date}
                                    </div>
                                    <div className='time'>
                                        {Math.ceil((item.body ? item.body.split(/\s+/).length : 1) / 200)} min read
                                    </div>
                                </div>
                                <div className='bodyer'>
                                    {item.body}
                                </div>
                                <div className='readmore bodyer'>READ MORE</div></div>

                            {item.image && <img className="imgt" src={item.image} />}
                        </Link>
                        </div>
                    ))}
                    {/* <button onClick={()=>{console.log(artdata)}}>waow</button> */}
                </div>

            </div>
        </div>
    </>)
}
